import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { invalidateSubprocessenForEntityAfterTimeout } from '../../subprocessen/util/subproces-util'
import { completeAssignedBijlageForEntity } from '../services/completeAssignedBijlageForEntity'

import { queryKey as queryKeyAssignedBijlagen } from './useAssignedBijlagenForEntity'

export { useCompleteAssignedBijlageForEntity }

const useCompleteAssignedBijlageForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: completeAssignedBijlageForEntity,
    onSuccess: (_, variables) => {
      successAlert(
        `Bijlage successvol opgeleverd${
          variables.assignedTo ? ' voor review' : ''
        }`,
      )

      queryClient.invalidateQueries({ queryKey: [queryKeyAssignedBijlagen] })

      invalidateSubprocessenForEntityAfterTimeout(queryClient, variables.entity)
    },
  })
}
